import React, { Component } from 'react'
import Slider from 'react-rangeslider'

import Play from "./play.svg";
import Pause from "./pause.svg";

import "./index.css";

class AudioPlayer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            duration: 0,
            currentTime: 0,
        }

        this.Audio = new Audio(props.src);
    }

    componentDidUpdate(newProps) {
        if (newProps.src && newProps.src !== this.Audio.src) {
            this.Audio.pause();
            this.Audio.setAttribute("src", newProps.src)
        }
    }

    componentDidMount() {
        this.Audio.oncanplay = (evt) => {
            const { duration } = evt.target;
            this.setState({ duration: Math.floor(duration) });
        }

        this.Audio.ontimeupdate = (evt) => {
            const { currentTime } = evt.target;
            this.setState({ currentTime: Math.floor(currentTime) });
        }
    }

    componentWillUnmount() {
        this.Audio.pause();
        this.Audio.oncanplay = null;
        this.Audio.ontimeupdate = null;

        this.Audio = null;
    }

    onPlayPauseClick = () => {
        if (this.Audio.paused) {
            this.Audio.play();
        } else {
            this.Audio.pause();
        }
    }

    handleSliderChange = (value) => {
        this.Audio.currentTime = value;
    }

    formatTime(seconds) {
        let minutes = Math.floor(seconds / 60);
        seconds = Math.floor(seconds % 60);
        seconds = (seconds >= 10) ? seconds : "0" + seconds;
        return minutes + ":" + seconds;
    }

    render() {
        const isPaused = this.Audio.paused;
        const canPlay = this.state.duration > 0;

        return (
            <div className={"AudioPlayer"}>
                <div className="container">
                    <div className="oval">
                        <button
                            type="button"
                            disabled={!canPlay}
                            className={isPaused ? "oval-btn play" : "oval-btn pause"}
                            aria-label={isPaused ? "Play" : "Pause"}
                            onClick={this.onPlayPauseClick}>
                            <img src={isPaused ? Play : Pause} />
                        </button>
                        <div className="text"> {this.props.translations.playTheVoiceOver[this.props.countryCode]} </div>
                    </div>
                    <div className="progress">
                        <Slider
                            min={0}
                            max={this.state.duration}
                            value={this.state.currentTime}
                            onChange={this.handleSliderChange}
                            tooltip={false}
                        />
                    </div>
                    <div className="time"> {`${this.formatTime(this.state.currentTime)} / ${this.formatTime(this.state.duration)}`} </div>
                </div>
            </div>
        )
    }
}

export default AudioPlayer;
